<template>
  <div style="width: 400px;height: 400px;" :id="infoPicId" />
</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "InfoCard",
  data(){
    return {
      infoPicId: '',
      info: {
        types: [],
        spotSize: 1,
        tip: [],
        source: []
      },
      info_pic_type: 1,
      COLOR_ALL: [
        '#37A2DA', '#e06343', '#37a354', '#b55dba',
        '#b5bd48', '#8378EA', '#96BFFF', '#E72178',
        '#354E6C', '#EAAC31', '#EAD2AE', '#127678',
        '#30B5A4', '#B4D9D2', '#354581','#FFE074',
        '#E03C79', '#88C1B8', '#FC6746','#F5B307',
        '#008186'
      ],
      xAxis_name: 'x',
      yAxis_name: 'y',
    }
  },
  props:{
    cardID: String,
  },
  mounted() {
    this.infoPicId = 'info_pic' + this.cardID
    // console.log(this.$attrs)
    // this.$attrs.data.info_type
    this.info = this.$attrs.data.info
    this.info_pic_type = this.$attrs.data.info_pic_type
    // console.log(this.$attrs.data.info_type)
    this.$nextTick(function () {
      this.initInfoEcharts()
    })
  },
  methods: {
    initInfoEcharts(){

      let _this = this
      if (this.$attrs.data.info_type.includes('tsne') || this.$attrs.data.info_type.includes('TSNE')){
        this.xAxis_name = 'tsne_1'
        this.yAxis_name = 'tsne_2'
      }
      else if (this.$attrs.data.info_type.includes('umap') || this.$attrs.data.info_type.includes('UMAP')){
        this.xAxis_name = 'umap_1'
        this.yAxis_name = 'umap_2'
      } else {
        this.xAxis_name = 'x'
        this.yAxis_name = 'y'
      }

      let option_type1 = {
        title:{
          text: _this.$attrs.data.info_type,
          left: 'center'
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage : {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        dataset: {
          source: _this.info.source
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          categories: _this.info.types,
          inRange: {
            color: ['#37A2DA','#e06343','#37a354','#b55dba','#b5bd48','#8378EA','#96BFFF','#E72178',
              '#354E6C','#EAAC31','#EAD2AE','#127678','#30B5A4','#B4D9D2','#354581','#FFE074',
              '#E03C79','#88C1B8','#FC6746','#F5B307','#008186'
            ]
          },
        },
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        // legend: {
        //   type: 'scroll',
        //   orient: 'horizontal',
        //   x:'center',
        //   y:'bottom',
        //   data: _this.info.types
        // },
        xAxis: {
          type: 'value',
          name: this.xAxis_name,
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: this.yAxis_name,
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [{
          show: false,
          name: _this.info.types[0],
          type: 'scatter',
          encode: { x: ['x'],  y: ['y'], tooltip: [0,1,2]},
          symbolSize: _this.info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal:{
              color: function (p){
                let index = _this.info.types.indexOf(p.value[0])
                // if(p.data[0] === 'NA'){console.log(p.data)}
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }
      let option_type2 = {
        title:{
          text: _this.$attrs.data.info_type,
          left: 'center'
        },
        dataset: {
          source: _this.info.source
        },
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        tooltip: {
          show: true,
          position: 'bottom'
        },
        visualMap: {
          type: 'piecewise',
          top: 'middle',
          right: 0,
          dimension: 0,
          seriesIndex: 0,
          // pieces: _this.echart_info_celltype2.umap_celltype.tip,
          categories: _this.info.types,
          inRange: {
            color: ['#37A2DA', '#e06343', '#37a354', '#b55dba', '#b5bd48', '#8378EA', '#96BFFF', '#E72178',
              '#354E6C', '#EAAC31', '#EAD2AE', '#127678', '#30B5A4', '#B4D9D2', '#354581', '#FFE074',
              '#E03C79', '#88C1B8', '#FC6746', '#F5B307', '#008186'
            ]
          },
          // formatter: function (value) {
          //   return value.length > 10 ? value.substring(0,7)+'...':value; // 范围标签显示内容。
          // },
        },
        grid: {
          right: 100
        },
        xAxis: {
          name: this.xAxis_name,
          nameGap: 25,
          nameLocation: "middle",
          type: 'value'
        },
        yAxis: {
          name:  this.yAxis_name,
          nameGap: 25,
          nameLocation: "middle",
          type: 'value'
        },
        series: [{
          name: 'Detail',
          type: 'scatter',
          encode: {x: ['x'], y: ['y'], tooltip: [0, 1, 2]},
          symbolSize: _this.info.spotSize,
          // symbolSize: 10,
          itemStyle: {
            // color: '#ff0000'
            normal: {
              color: function (p) {
                let index = _this.info.types.indexOf(p.value[0])
                return _this.COLOR_ALL[index]
              }
            }
          }
        }]
      }

      let info_div = document.getElementById(_this.infoPicId);
      const chart_info = echarts.init(info_div);

      let option;
      if (this.info_pic_type === 1){
        option = option_type1;
      }else {
        option = option_type2;
      }
      option && chart_info.setOption(option);


    },
  }
}
</script>

<style scoped>

</style>
